"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var drivingLicenceHelpers = {
    validateLastNameSection: function (lastName, licencePart) {
        if (!lastName || !licencePart) {
            return false;
        }
        var formatName = lastName.replace(/\s|-|'/g, "");
        var lastNameStart = formatName.length >= 5 ? formatName.substring(0, 5).toUpperCase() : formatName.toUpperCase();
        if (formatName.length < 5) {
            for (var i = lastNameStart.length; i < 5; i++) {
                lastNameStart = lastNameStart + "9";
            }
        }
        if (formatName.toUpperCase().startsWith("MAC")) {
            if (formatName.length >= 6) {
                lastNameStart = "MC" + formatName.substring(3, 6).toUpperCase();
            }
            else {
                lastNameStart = "MC" + formatName.substring(3).toUpperCase();
                for (var i = lastNameStart.length; i < 5; i++) {
                    lastNameStart = lastNameStart + "9";
                }
            }
        }
        return lastNameStart === licencePart;
    },
    validateBirthDateSection: function (dateOfBirth, licencePart) {
        if (!dateOfBirth || !licencePart) {
            return false;
        }
        var digitRegex = /^\d+$/;
        if (!digitRegex.test(licencePart)) {
            return false;
        }
        var date = moment.utc(dateOfBirth, moment.ISO_8601);
        var decadeNumber = date.year().toString().substring(2, 3);
        var yearNumber = date.year().toString().substring(3);
        var month = date.month() + 1;
        var licenceMonth = licencePart.substring(1, 3);
        var dayOfMonth = date.date() < 10 ? "0" + date.date().toString() : date.date().toString();
        var monthValid = (month + 50).toString() === licenceMonth ||
            month.toString() === licenceMonth || "0" + month.toString() === licenceMonth;
        return decadeNumber === licencePart.substring(0, 1) && yearNumber === licencePart.substring(5) &&
            monthValid && dayOfMonth === licencePart.substring(3, 5);
    },
    validateFirstNameSection: function (firstName, licencePart) {
        if (!firstName || !licencePart) {
            return false;
        }
        var names = firstName.split(" ");
        var firstNameInitial = names[0].substring(0, 1).toUpperCase();
        return firstNameInitial === licencePart.substring(0, 1);
    }
};
exports.default = drivingLicenceHelpers;
//# sourceMappingURL=drivingLicenceHelper.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/helpers/drivingLicenceHelper.js
// module id = 1236
// module chunks = 0